export const HOME = { label: 'Home', url: '/' };

export const LOG_EXPLORER = '/monitoring-dashboard/log-explorer';

export const healthChecks = [
  { label: 'Monitoring Dashboard', url: '/monitoring-dashboard' },
  { label: 'Health Checks', url: '/monitoring-dashboard/health-checks' },
];

export const logExplorer = [
  { label: 'Monitoring Dashboard', url: '/monitoring-dashboard' },
  { label: 'Log Explorer', url: '/monitoring-dashboard/log-explorer' },
];
